export const refreshCounter = name => ({ type: 'REFRESH_COUNTER', name })
